import { Wrench } from 'lucide-react';
import { SystemMessageLayout } from '../ui/SystemMessageLayout';

export function Maintenance() {
  return (
    <SystemMessageLayout
      statusCode={503}
      icon={<Wrench className="w-12 h-12 text-warning-500" strokeWidth={1.5} />}
      title="System Maintenance"
      description="We're currently performing scheduled maintenance to improve our services. We'll be back online shortly. Thank you for your patience."
      action={{
        label: 'Refresh Page',
        onClick: () => window.location.reload(),
      }}
    />
  );
}
